import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import FiltroReportes from "../Components/FiltroReportes";
import FiltroReportesMes from "../Components/FiltroReportesMes";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const ReporteProyeccionMensual = () => {
    const history = useHistory();
    const { state } = useLocation();
    const permisos = state.permisos;
    const [clientes, setClientes] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const [totalSaldo, setTotalSaldo] = useState(0);
    const [totalPagado, setTotalPagado] = useState(0);
    const [totalImporte, setTotalImporte] = useState(0);
    const [ejercicioTitulo, periodoTitulo] = state.mes.split("-");
    const [ejercicioTituloFiltrado, periodoTituloFiltrado] = boxstate.mes ? boxstate.mes.split("-") : [null, null];
    const [titulo, setTitulo] = useState("PROYECCION DE RECUPERACION DE CARTERA")
    const [totalImporteFactura, setTotalImporteFactura] = useState(0);
    const [totalInteresNormal, setTotalInteresNormal] = useState(0);
    const [totalInteresMoratorio, setTotalInteresMoratorio] = useState(0);
    const [totalImporteTotal, setTotalImporteTotal] = useState(0);
    const [totalSaldoTotal, setTotalSaldoTotal] = useState(0);

    const storedState = JSON.parse(localStorage.getItem('state')) || {};
    const newejercicio = storedState.ejercicio || boxstate.ejercicio;
    const newperiodo = storedState.periodo || boxstate.periodo;

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    // console.log(state)

    const nombreMes = (monthNumber) => {
        switch (monthNumber) {
            case '01': return 'ENERO';
            case '02': return 'FEBRERO';
            case '03': return 'MARZO';
            case '04': return 'ABRIL';
            case '05': return 'MAYO';
            case '06': return 'JUNIO';
            case '07': return 'JULIO';
            case '08': return 'AGOSTO';
            case '09': return 'SEPTIEMBRE';
            case '10': return 'OCTUBRE';
            case '11': return 'NOVIEMBRE';
            case '12': return 'DICIEMBRE';
            default: return '';
        }
    };

    const getTipoCartera = (tipo_cartera) => {
        switch (tipo_cartera) {
            case 'Operación': return 'O';
            case 'Revolvente': return 'R';
            case 'Especial': return 'E';
            default: return '';
        }
    };

    const [stateFiltro, setStateFiltro] = useState({
        ejercicio: storedState.ejercicio || boxstate.ejercicio,
        adr: (storedState.adr ? storedState.adr.filter(item => item.checked).map(({ idadr, adr }) => ({ idadr, adr })) : boxstate.pv.adr),
        sucursal: (storedState.sucursal ? storedState.sucursal.filter(item => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal })) : boxstate.pv.sucursal)
    });

    useEffect(() => {
        setStateFiltro({
            ejercicio: storedState.ejercicio || boxstate.ejercicio,
            adr: boxstate.pv.adr,
            sucursal: boxstate.pv.sucursal
        });
    }, [boxstate]);

    useEffect(() => {
        onExecute(state.ejercicio, state.periodo, state.mes, getTipoCartera(state.tipo_cartera));
    }, []);

    // console.log(boxstate)

    const onExecute = (ejercicio, periodo, mes, tipo_cartera) => {
        var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
        var adr = GetKey(stateFiltro.adr, ["idadr"]);
        if (adr === undefined || adr === null || adr === "") {
              adr = "0";
            }
            if (sucursales === undefined || sucursales === null || sucursales === "") {
              if(adr === "0" || adr === "1,2")
              {
                sucursales = GetKey(permisos, ["idsucursal"]);
                
              }
              else {
              sucursales = "0"
              }
            }
        // console.log(adr, sucursales)
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardReportes/ReporteProyeccionMensual?mes=${mes}&sucursales=${sucursales}&adr=${adr}&tipo_cartera=${getTipoCartera(state.tipo_cartera)}`

                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    calcularTotalSaldo(result);
                    calcularTotalRecuperado(result);
                    calcularTotalImporte(result);
                    calcularTotalImporteFactura(result)
                    calcularTotalImporteTotal(result)
                    calcularTotalInteresNormal(result)
                    calcularTotalInteresMoratorio(result)
                    calcularTotalImporteTotal(result)
                    calcularTotalSaldoTotal(result)
                    setTitulo(`PROYECCION DE RECUPERACION DE CARTERA ` + (state.tipo_cartera === 'Operación' ? 'DE ' : '') + state.tipo_cartera.toUpperCase() + ' ' + (nombreMes(periodoTituloFiltrado) || nombreMes(periodoTitulo)) + ' ' + (ejercicioTituloFiltrado || ejercicioTitulo))
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const onGeneraExcel = (ejercicio, periodo, mes) => {
        var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
        var adr = GetKey(stateFiltro.adr, ["idadr"]);
        if (adr === undefined || adr === null || adr === "") {
              adr = "0";
            }
            if (sucursales === undefined || sucursales === null || sucursales === "") {
              if(adr === "0" || adr === "1,2")
              {
                sucursales = GetKey(permisos, ["idsucursal"]);
                
              }
              else {
              sucursales = "0"
              }
            }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`DashboardReportes/ImprimirExcelReporteProyeccionMensual?ejercicio=${ejercicio}&periodo=${periodo}&mes=${mes}&sucursales=${sucursales}&adr=${adr}&tipo_cartera=${getTipoCartera(state.tipo_cartera)}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onGeneraPDF = (ejercicio, periodo, mes) => {
        var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
        var adr = GetKey(stateFiltro.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = GetKey(permisos, ["idsucursal"]);
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`DashboardReportes/ImprimirPDFReporteProyeccionMensual?ejercicio=${ejercicio}&periodo=${periodo}&mes=${mes}&sucursales=${sucursales}&adr=${adr}&tipo_cartera=${getTipoCartera(state.tipo_cartera)}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const formatearFecha = (fechaStr) => {
        const fecha = new Date(fechaStr);
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
      
        return `${dia}/${mes}/${anio}`;
      };

    const calcularTotalSaldo = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.saldo) || 0), 0);
        setTotalSaldo(total);
    };

    const calcularTotalRecuperado = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.pagado) || 0), 0);
        setTotalPagado(total);
    };

    const calcularTotalImporte = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.importe_factura) || 0), 0);
        setTotalImporte(total);
    };

    const calcularTotalImporteFactura = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.importe_factura) || 0), 0);
        setTotalImporteFactura(total);
    };

    const calcularTotalInteresNormal = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.interes_normal) || 0), 0);
        setTotalInteresNormal(total);
    };

    const calcularTotalInteresMoratorio = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.interes_moratorio) || 0), 0);
        setTotalInteresMoratorio(total);
    };

    const calcularTotalImporteTotal = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.importe_total) || 0), 0);
        setTotalImporteTotal(total);
    };

    const calcularTotalSaldoTotal = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.saldo_total) || 0), 0);
        setTotalSaldoTotal(total);
    };


    const onGestion = (idcliente, razonsocial, responsable) => {
        if (idcliente.toString().length <= 6) {
            history.push("/Creditoycobranza/DetalleClientesGestionar", {
                idcliente,
                razonsocial,
                responsable
            });
        } else {
            Swal.fire("CREDITO Y COBRANZA", "El cliente no se encuentra registrado", "error");
        }
    };

    const GetLinea = (linea) =>{
        switch (linea){
            case 'O':
                return 'Operación';
                case 'R':
                    return 'Revolvente';
                    case 'E':
                        return 'Especial';
        }
    }
    // console.log(clientes)
    return (
        <PlantillaScreen
            titulo={titulo}
            className_main={1}
            className={"reporte-recuperacion-responsable"}
        >
            <LoaderScreen loader={loader} />
            <div className="reporte-recuperacion-responsable-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => history.push('/Creditoycobranza/DashboardCobranza')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-recuperacion-responsable-actions-filtro">
                    <FiltroReportesMes
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        estadoinicial={state.mes}
                        sucursales={permisos}
                    />
                </div>
                <div className="buttons">
                    <button className="excel"
                        onClick={() => onGeneraExcel(newejercicio, newperiodo, (boxstate.mes || state.mes))}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    {/* <button className="PDF"
                        onClick={() => onGeneraPDF(newejercicio, newperiodo, (boxstate.mes || state.mes))}
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button> */}
                </div>
            </div>
            <div className="reporte-recuperacion-responsable-header">
                <div className="reporte-recuperacion-responsable-header-title">
                    <FormatListNumberedIcon /> Listado de Clientes
                </div>
                <div className="contador-convenios-encontrados">
                    Clientes Encontrados: {clientes.length}
                </div>
            </div>
            <div className="reporte-recuperacion-responsable-container scroll">
                <div className="reporte-recuperacion-responsable-container-table">
                <table>
                        <thead>
                            <tr>

                                <th className="sticky-col">
                                    Línea
                                </th>
                                <th className="sticky-col-2">
                                    <div>Cliente</div>
                                </th>
                                <th><div>Sucursal</div></th>
                                <th>
                                    <div>Vencimiento</div>
                                </th>
                                <th>
                                    <div>Importe de Factura</div>
                                </th>
                                <th>
                                    <div>Recuperado</div>
                                </th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                                <th>
                                    <div>Int. Normal</div>
                                </th>
                                <th>
                                    <div>Int. Moratorio</div>
                                </th>
                                {/* <th>
                                    <div>Total</div>
                                </th> */}
                                <th>
                                    <div>Saldo Total</div>
                                </th>
                                <th>
                                    <div>Fecha de Recuperación</div>
                                </th>
                                <th>
                                    <div>Fecha de Contacto</div>
                                </th>
                                <th>
                                    <div>Fecha Compromiso</div>
                                </th>
                                <th>
                                    <div>Convenio</div>
                                </th>
                                <th>
                                    <div>Objeción</div>
                                </th>
                                <th>
                                    <div>Observaciones</div>
                                </th>
                                <th>
                                    <div>Responsables</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((clt) => (
                                <tr onClick={() =>
                                    onGestion(clt.idcliente_HD != 0 ? clt.idcliente_HD : clt.idcliente, clt.cliente, 0)
                                }>

                                    <td className="linea-celda sticky-col">{GetLinea(clt.linea_credito)}</td>
                                    <td className="razon-social-celda sticky-col-2">{capitalizePalabras(clt.cliente)}</td>
                                    <td className="ta-center sucursal-celda">{capitalizePalabras(clt.sucursal)}</td>
                                    <td className="vencimiento-celda">{formatearFecha(clt.vencimiento_factura)}</td>
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.importe_factura, 2)}</td>
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.pagado, 2)}</td>
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.saldo, 2)}</td>
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.interes_normal, 2)}</td>
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.interes_moratorio, 2)}</td>
                                    {/* <td className="ta-right saldo-celda">{FormatMoney(clt.importe_total, 2)}</td> */}
                                    <td className="ta-right saldo-celda">{FormatMoney(clt.saldo_total, 2)}</td>
                                    <td className="fecha-celda">{clt.fecha_recuperacion}</td>
                                    <td className="fecha-celda">{clt.fecha_contacto}</td>
                                    <td className="fecha-celda">{clt.fecha_convenio}</td>
                                    <td className="ta-center convenio-celda">{capitalizePalabras(clt.tiene_convenio)}</td>
                                    <td className="objecion-celda">{capitalizePalabras(clt.objecion)}</td>
                                    <td className="observaciones-celda">{clt.observaciones}</td>
                                    <td className="responsable-celda">{capitalizePalabras(clt.responsable)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="ta-right"></td>
                                <td className="ta-right"></td>
                                <td className="ta-right"></td>
                                <td className="ta-right">Total:</td>
                                <td className="ta-right">
                                    {FormatMoney(totalImporteFactura, 2)}
                                </td>
                                <td className="ta-right">
                                    {FormatMoney(totalPagado, 2)}
                                </td>
                                <td className="ta-right">
                                    {FormatMoney(totalSaldo, 2)}
                                </td>
                                <td className="ta-right">
                                    {FormatMoney(totalInteresNormal, 2)}
                                </td>
                                <td className="ta-right">
                                    {FormatMoney(totalInteresMoratorio, 2)}
                                </td>
                                {/* <td className="ta-right">
                                    {FormatMoney(totalImporteTotal, 2)}
                                </td> */}
                                <td className="ta-right">
                                    {FormatMoney(totalSaldoTotal, 2)}
                                </td>
                                <td className="ta-right" colSpan={7}></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};